const selectors = ({ store }) => ({
    getState: (state) => state[store],
    getStatus: (state) => state[store].status,
    getDashboardPricing: (state) => state[store].pricing.dashboardPricing,
    getApplicationFees: (state) => state[store].pricing.applicationFees,
})

export default selectors
